import { useCompanyStore } from "@/entities/company/model";
import { useDeviceStore } from "@/entities/device/model";
import { useEvaluationStore } from "@/entities/evaluation/model";
import { useWidgetContext } from "@/shared/config";
import { useGlobalStore } from "@/shared/model";
import { startViewTransition } from "@/shared/ui";

/** Начать trade-in заново или закрыть виджет. Оба действия сбрасывают введённые данные и вызывают onDrop */
export function useResetTradeIn() {
    const { api } = useWidgetContext();
    const globalStore = useGlobalStore();
    const companyStore = useCompanyStore();
    const deviceStore = useDeviceStore();
    const evaluationStore = useEvaluationStore();

    function resetTradeIn(): void {
        deviceStore.reset();
        companyStore.reset();
        evaluationStore.reset();
        api.onDrop?.();
    }

    // Stores are reset inside the transition, so the old snapshot keeps the filled screen
    function restart(): void {
        void startViewTransition(() => {
            resetTradeIn();
            globalStore.resetStep();
        });
    }

    function close(): void {
        globalStore.closeWidget();
        resetTradeIn();
    }

    return { restart, close };
}
